import styled from "styled-components";

export const ContainerPage = styled.main`
  width: 100%;
  height: 100%;
`;

export const ContainerStyled = styled.main`
  width: 100%;
  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;

  background: ${({ theme }) => theme.signupBackground};
  background-size: cover;
  background-position: center center;
`;

export const FormContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  form {
    width: 500px;
    flex-direction: column;
    padding: 40px;

    background: ${({ theme }) => theme.signupFormBackground};
    border: 1px solid ${({ theme }) => theme.signupFormBorder};

    p {
      font: 500 0.8rem "Roboto", sans-serif;
      color: red;
      text-align: center;
    }

    @media (max-width: 450px) {
      transition: 1.8s all;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100vh;
      border: 0;
    }

    @media (max-height: 800px) {
      transition: 1.8s all;
      padding: 10px 40px;
    }

    @media (max-height: 745px) {
      padding: 0px 40px 10px 40px;
    }
  }

  .login-form {
    width: 100%;
    margin-top: 10px;
  }

  .login-form input {
    width: 100%;
    padding: 12px;
    margin: 6px 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${({ theme }) => theme.signupFormInputBackground};
    border: 1px solid ${({ theme }) => theme.signupFormBorder};
    outline: 0;

    @media (max-height: 650px) {
      transition: 1.8s all;
      padding: 8px;
      margin: 3px 0;
    }
  }

  .login-form input:active {
    background-color: ${({ theme }) => theme.signupFormInputBackground};
    border: 1px solid ${({ theme }) => theme.signupFormBorder};
  }

  .login-form input:focus {
    background-color: ${({ theme }) => theme.signupFormInputBackground};
    border: 1px solid ${({ theme }) => theme.signupFormBorder};
  }

  .login-form input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px
      ${({ theme }) => theme.signupFormInputBackground} inset;
    box-shadow: 0 0 0 1000px ${({ theme }) => theme.signupFormInputBackground}
      inset;
  }

  h2 {
    font: 700 1.2rem "Roboto", sans-serif;
    width: 100%;
    padding: 40px 0px 20px 0px;
    align-self: flex-start;
    border-bottom: 1px solid #ccc;
    color: ${({ theme }) => theme.signupFormText};
  }

  h3 {
    font: 500 1rem "Roboto", sans-serif;
    align-self: flex-start;
    color: ${({ theme }) => theme.signupFormText};
  }
`;

export const ButtonSubmitted = styled.button`
  font: 700 1rem "Roboto", sans-serif;
  color: ${({ theme }) => theme.signupFormButtonSubmittedText};

  width: 100%;
  margin-top: 25px;

  padding: 16px 100px;
  border: 0;
  background: ${({ theme }) => theme.signupFormButtonSubmittedBackground};

  cursor: pointer;

  &:active {
    transform: translateY(4px);
  }

  @media (max-width: 500px) {
    transition: 1.8s all;
    padding: 8px 100px;
    line-height: 1.5;
  }
`;

export const ButtonSignin = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  background: ${({ theme }) => theme.signupFormButtonSigninBackground};
  border: 0;

  font: 700 1rem "Roboto", sans-serif;
  color: ${({ theme }) => theme.signupFormButtonSigninText};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    transition: 1s;
    transform: translateY(4px);
  }
`;
